import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizationCreateFormFactory } from './organization-create-form.factory';
import { OrganizationCreationOptions } from '../../../../../../../../common/src/options/organization-creation.options';
import { take } from 'rxjs/operators';
import { AlertMessageStore } from '../../../../../../modules/src/lib/core/stores/alert-message.store';
import { LoggingService } from '../../../../../../modules/src/lib/core/services/logging.service';
import { AlertMessageModel } from '../../../../../../modules/src/lib/core/models/alert-message.model';
import { SeverityTypeEnum } from '../../../../../../modules/src/lib/core/enums/severity-type.enum';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { AlertContextEnum } from '../../../../../../modules/src/lib/core/enums/alert-context.enum';
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';
import { environment } from '../../../../environments/environment';
import { AuthService } from '@auth0/auth0-angular';
import { OrganizationManager } from '../../../managers/organization.manager';

@Component({
  selector: 'app-organization-create',
  templateUrl: './organization-create.component.html',
  styleUrls: ['./organization-create.component.scss'],
  standalone: false,
})
export class OrganizationCreateComponent implements OnInit {

  public readonly form: AdvancedForm<OrganizationCreationOptions> = this.formFactory.create();

  constructor(public readonly formFactory: OrganizationCreateFormFactory,
              private readonly organizationManager: OrganizationManager,
              public readonly authService: AuthService,
              private readonly alertMessageStore: AlertMessageStore,
              private readonly loggingService: LoggingService,
              private readonly router: Router) {
  }

  get organizationName(): AdvancedFormControl<string, string, string> {
    return this.form.formElements.organizationName as AdvancedFormControl<string, string, string>;
  }

  ngOnInit(): void {
    this.authService.getAccessTokenSilently({
      authorizationParams: {
        audience: environment.auth0Audience,
        scope: 'openid profile email read:all',
      },
    }).subscribe(value => {
    }, error => {
      this.authService.getAccessTokenWithPopup({
        authorizationParams: {
          audience: environment.auth0Audience,
          scope: 'openid profile email read:all',
        },
      }).subscribe(value => {
      }, error => {
      });
    });

    this.form.buttonClick$.subscribe(() => {
      this.loggingService.debug('yeah, valid form');
      this.form.lifecycleStatus = FormLifecycleStatusEnum.Sending;

      this.loggingService.debug(JSON.stringify(this.form.value));
      const options: OrganizationCreationOptions = this.form.value;
      this.authService.idTokenClaims$.pipe(take(1)).toPromise().then(value => {
        options.email = value.email;
        this.loggingService.debug('[organization-create] - Options retrieved from the form', options);

        this.organizationManager.create(options).then(async (response) => {
          this.alertMessageStore.save(new AlertMessageModel(SeverityTypeEnum.Success, AlertContextEnum.Global, {
            fr: 'L\'entreprise a bel et bien été créée. Vous allez être redirigé sous peu.',
            en: 'The organization has been properly created. You will be redirected soon.',
          }));

          this.loggingService.debug('[organization-create] - Response returned', response);

          this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;

          // Why the fuck does navigateByUrl doesn't work in here??? it returns null so it seems like it thinks we are already elsewhere. Anyway, reloading works.
          // 2024-05-22: Well, now I know. I need to refresh the page because the Auth0 token must be refreshed, else the user's association with the organization
          // will not have been made.
          location.reload();
        }).catch(async error => {
          this.form.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
        });
      });
    });
  }

}
